class ScaleMonth {
	static seed(bar, dateTime) {
		let i = new ScaleMonth(bar);
		i.start = Date.UTC(dateTime.getFullYear(), dateTime.getUTCMonth());
		return i;
	}
	
	static before(bar, other) {
		let i = new ScaleMonth(bar);
		i.end = other.start;
		return i;
	}

	static after(bar, other) {
		let i = new ScaleMonth(bar);
		i.start = other.end;
		return i;
	}

	constructor(bar) {
		this._scale = bar._scale;
		this._start;
		this._end;
		this._width;

		this._elem = UI.div('scaleMonth', this._text = UI.span());
		bar._monthBar.appendChild(this._elem);
	}

	dispose() {
		this._elem.remove();
	}

	get start() {return this._start;}
	get end() {return this._end;}

	set start(v) {
		this._start = v;
		let dt = new Date(v);
		this._text.innerHTML = App.MTH[dt.getUTCMonth()] + ' ' + dt.getFullYear();
		dt.setUTCMonth(dt.getUTCMonth() + 1);
		this._end = dt.getTime();
		this.size();
	}

	set end(v) {
		this._end = v;
		let dt = new Date(v);
		dt.setUTCMonth(dt.getUTCMonth() - 1);
		this._text.innerHTML = App.MTH[dt.getUTCMonth()] + ' ' + dt.getFullYear();
		this._start = dt.getTime();
		this.size();
	}

	size() {
		this._width = this._scale._timeline.millisecsToPixels(this._end - this._start);
		this._elem.style.width = this._width + 'px';
	}

	move() {
		let left = this._scale._timeline.timeToOffset(this._start);
		
		this._elem.style.left = left + 'px';

		if (0 < left) {
			this._text.style.left = '5px';
		} else if (this._text.offsetWidth - this._width + 10 < left) {
			this._text.style.left = (-left + 5) + 'px';
		} else {
			this._text.style.left = (this._width - this._text.offsetWidth - 5) + 'px';
		}
	}
}
